module.exports = __webpack_public_path__ + "static/media/shield-icon.1d8cb3a1.svg";